import styled from 'styled-components';
import Modal from 'components/common/Modal';
import palette from 'lib/styles/palette';
import useControllerListModal from 'hooks/service/useControllerListModal';
import Loading from 'components/common/Loading';

const ControllerItem = ({ row }) => {
  return (
    <ControllerItemBlock>
      <div>{row.store}</div>
      <div>{row.space}</div>
      <div>{row.controller}</div>
      <div>{row.power === 'OFF' ? '종료' : '운행'}</div>
    </ControllerItemBlock>
  );
};

const ControllerItemBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;

  div {
    width: 200px;
    text-align: center;
  }
`;

const ControllerListModal = ({ onClose }) => {
  const { isLoading, error, data } = useControllerListModal();

  return (
    <Modal
      closeModal={onClose}
      header={{ text: '전체 컨트롤러 리스트', width: 898 }}
      style={{ height: 600 }}
    >
      <ControllerListModalBlock>
        {isLoading || error?.response.status === 401 ? (
          <Loading style={{ width: 500, height: 400 }} />
        ) : error?.response.status === 500 ? (
          <div style={{ marginTop: 30, marginBottom: 30, fontWeight: 'bold' }}>
            서버 오류가 발생했습니다
          </div>
        ) : (
          <>
            <div className="controller-list-modal-box">
              <div className="controller-list-modal-box-header">
                <div>매장명</div>
                <div>층/공간명</div>
                <div>컨트롤러 이름</div>
                <div>상태</div>
              </div>
              {data?.data.rows.map((row, index) => (
                <ControllerItem key={`${row.store}${index}`} row={row} />
              ))}
            </div>
            <button onClick={onClose}>닫기</button>
          </>
        )}
      </ControllerListModalBlock>
    </Modal>
  );
};

export default ControllerListModal;

const ControllerListModalBlock = styled.div`
  padding: 0 2rem;
  padding-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  .controller-list-modal-box {
    margin-top: 1rem;
    padding: 1rem;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .controller-list-modal-box-header {
    padding-bottom: 1rem;
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    div {
      width: 200px;
      text-align: center;
    }
  }

  button {
    margin-top: 1rem;
    padding: 0.5rem 2rem;
    border: none;
    color: white;
    border-radius: 10px;
    background: ${palette.theme[3]};
    cursor: pointer;
    &:hover {
      background: ${palette.theme[2]};
    }
  }
`;
